// extracted by mini-css-extract-plugin
export default {"container":"RegistrationPage_container__tVNq-","contentWrapper":"RegistrationPage_contentWrapper__mp4oZ"};